import {createAction} from "lib/actions";

export const FETCH_ALL = "SCHOOL_MONEY/FETCH_ALL";

export function fetchAll(forceSchoolFetch, forceStudentFetch, forceParentFetch, forceActivePaymentFetch, forceShopFetch, forceHistoryFetch) {
  return createAction(FETCH_ALL, false, {forceSchoolFetch, forceStudentFetch, forceParentFetch, forceActivePaymentFetch, forceShopFetch, forceHistoryFetch});
}

// secure trading

export const SECURE_TRADING_PROCESS_TOKEN = "SCHOOL_MONEY/SECURE_TRADING_PROCESS_TOKEN";
export const SECURE_TRADING_PROCESS_TOKEN_COMPLETED = "SCHOOL_MONEY/SECURE_TRADING_PROCESS_TOKEN_COMPLETED";
export const SECURE_TRADING_THREEDS_STATUS_UPDATE = "SCHOOL_MONEY/SECURE_TRADING_THREEDS_STATUS_UPDATE";
export const SECURE_TRADING_RESET = "SCHOOL_MONEY/SECURE_TRADING_RESET";
export const SECURE_TRADING_RESET_COMPLETED = "SCHOOL_MONEY/SECURE_TRADING_RESET_COMPLETED";
export const SECURE_TRADING_THREEDS_RESPONSE = "SCHOOL_MONEY/SECURE_TRADING_THREEDS_RESPONSE";
export const SECURE_TRADING_GET_JWT_STRING = "SCHOOL_MONEY/SECURE_TRADING_GET_JWT_STRING";
export const SECURE_TRADING_PROCESS_PAYMENT_RESPONSE = "SCHOOL_MONEY/SECURE_TRADING_PROCESS_PAYMENT_RESPONSE";
export const SECURE_TRADING_GET_JWT_STRING_COMPLETED = "SCHOOL_MONEY/SECURE_TRADING_GET_JWT_STRING_COMPLETED";

export function processSecureTradingToken(secureTrading) {
  return createAction(SECURE_TRADING_PROCESS_TOKEN, false, {secureTrading});
}

export function processSecureTradingTokenSucceeded(secureTrading) {
  return createAction(SECURE_TRADING_PROCESS_TOKEN_COMPLETED, false, {secureTrading});
}

export function updateSecureTradingThreeDSStatus(status) {
  return createAction(SECURE_TRADING_THREEDS_STATUS_UPDATE, false, {status});
}

export function resetSecureTrading() {
  return createAction(SECURE_TRADING_RESET, false);
}

export function resetSecureTradingSucceeded(secureTrading) {
  return createAction(SECURE_TRADING_RESET_COMPLETED, false, {secureTrading});
}

export function processSecureTrading3DSResponse(transactionID) {
  return createAction(SECURE_TRADING_THREEDS_RESPONSE, false, {transactionID});
}

export function getSecureTradingGetJwtString(cardHolderName){
  return createAction(SECURE_TRADING_GET_JWT_STRING, false, {cardHolderName});
}

export function getSecureTradingGetJwtStringComplete(jwtString){
  return createAction(SECURE_TRADING_GET_JWT_STRING_COMPLETED, false, {jwtString});
}

export function processSecureTradingPaymentResponse(paymentResult){
  return createAction(SECURE_TRADING_PROCESS_PAYMENT_RESPONSE, false, {paymentResult});
}

// parents

export const PARENTS_FETCH = "SCHOOL_MONEY/PARENTS_FETCH";
export const PARENTS_FETCH_COMPLETED = "SCHOOL_MONEY/PARENTS_FETCH_COMPLETED";
export const PARENT_EMAIL_ADDRESS_UPDATE = "SCHOOL_MONEY/PARENT_EMAIL_ADDRESS_UPDATE";

export function fetchParents(forceApiRefresh) {
  return createAction(PARENTS_FETCH, false, {forceApiRefresh});
}

export function fetchParentsSucceeded(parents) {
  return createAction(PARENTS_FETCH_COMPLETED, false, {parents});
}

export function updateParentEmailAddress(emailAddress) {
  return createAction(PARENT_EMAIL_ADDRESS_UPDATE, false, {emailAddress});
}

// schools

export const SCHOOLS_FETCH = "SCHOOL_MONEY/SCHOOLS_FETCH";
export const SCHOOLS_FETCH_COMPLETED = "SCHOOL_MONEY/SCHOOLS_FETCH_COMPLETED";

export function fetchSchools(forceApiRefresh) {
  return createAction(SCHOOLS_FETCH, false, {forceApiRefresh});
}

export function fetchSchoolsSucceeded(schools) {
  return createAction(SCHOOLS_FETCH_COMPLETED, false, {schools});
}

// students

export const STUDENTS_FETCH = "SCHOOL_MONEY/STUDENTS_FETCH";
export const STUDENTS_FETCH_COMPLETED = "SCHOOL_MONEY/STUDENTS_FETCH_COMPLETED";
export const SET_LAST_STUDENT = "SCHOOL_MONEY/SET_LAST_STUDENT";

export function fetchStudents(forceApiRefresh) {
  return createAction(STUDENTS_FETCH, false, {forceApiRefresh});
}

export function fetchStudentsSucceeded(students) {
  return createAction(STUDENTS_FETCH_COMPLETED, false, {students});
}

export function setLastStudent(studentID) {
  return createAction(SET_LAST_STUDENT, false, {studentID});
}

// credits

export const CREDITS_FETCH = "SCHOOL_MONEY/CREDITS_FETCH";
export const CREDITS_FETCH_COMPLETED = "SCHOOL_MONEY/CREDITS_FETCH_COMPLETED";
export const CREDIT_TOP_UP_ADD_TO_BASKET = "SCHOOL_MONEY/CREDIT_TOP_UP_ADD_TO_BASKET";
export const CREDIT_TOP_UP_REMOVE_FROM_BASKET = "SCHOOL_MONEY/CREDIT_TOP_UP_REMOVE_FROM_BASKET";

export function fetchCredits() {
  return createAction(CREDITS_FETCH);
}

export function fetchCreditsSucceeded(credits) {
  return createAction(CREDITS_FETCH_COMPLETED, false, {credits});
}

export function addCreditTopUpToBasket(creditType, studentID, amount) {
  return createAction(CREDIT_TOP_UP_ADD_TO_BASKET, false, {creditType, studentID, amount});
}

export function removeCreditTopUpFromBasket(creditType, studentID) {
  return createAction(CREDIT_TOP_UP_REMOVE_FROM_BASKET, false, {creditType, studentID});
}

// basket

export const BASKET_ITEM_SET = "SCHOOL_MONEY/BASKET_ITEM_SET";
export const BASKET_ITEM_DELETE = "SCHOOL_MONEY/BASKET_ITEM_DELETE";
export const BASKET_ITEM_DELETE_GROUP = "SCHOOL_MONEY/BASKET_ITEM_DELETE_GROUP";
export const BASKET_ITEMS_CLEAR = "SCHOOL_MONEY/BASKET_ITEMS_CLEAR";
export const BASKET_ITEMS_ISSUES_SET = "SCHOOL_MONEY/BASKET_ITEMS_ISSUES_SET";
export const BASKET_ITEMS_VALIDATE = "SCHOOL_MONEY/BASKET_ITEMS_VALIDATE";
export const BASKET_ITEMS_RESOLVE_ISSUES = "SCHOOL_MONEY/BASKET_ITEMS_RESOLVE_ISSUES";
export const BASKET_ITEMS_ISSUES_MODAL_OPEN = "SCHOOL_MONEY/BASKET_ITEMS_ISSUES_MODAL_OPEN";
export const BASKET_ITEMS_ISSUES_MODAL_CLOSE = "SCHOOL_MONEY/BASKET_ITEMS_ISSUES_MODAL_CLOSE";
export const SET_EXPANDED_SCHOOL_BASKET = "SCHOOL_MONEY/SET_EXPANDED_SCHOOL_BASKET";

export function setBasketItem(type, basketItemID, schoolID, studentID, groupID, price, quantity, payload) {
  return createAction(BASKET_ITEM_SET, false, {type, basketItemID, schoolID, studentID, groupID, price, quantity, payload});
}

export function deleteBasketItem(type, basketItemID) {
  return createAction(BASKET_ITEM_DELETE, false, {type, basketItemID});
}

export function deleteBasketItemGroup(type, groupID) {
  return createAction(BASKET_ITEM_DELETE_GROUP, false, {type, groupID});
}

export function clearBasketItems(schoolID) {
  return createAction(BASKET_ITEMS_CLEAR, false, {schoolID});
}

export function setBasketItemsIssues(issues) {
  return createAction(BASKET_ITEMS_ISSUES_SET, false, {issues});
}

export function validateBasketItems() {
  return createAction(BASKET_ITEMS_VALIDATE);
}

export function resolveBasketItemsIssues() {
  return createAction(BASKET_ITEMS_RESOLVE_ISSUES);
}

export function openBasketItemsIssuesModal() {
  return createAction(BASKET_ITEMS_ISSUES_MODAL_OPEN);
}

export function closeBasketItemsIssuesModal() {
  return createAction(BASKET_ITEMS_ISSUES_MODAL_CLOSE);
}

export function setExpandedSchoolBasket(schoolID) {
  return createAction(SET_EXPANDED_SCHOOL_BASKET, false, {schoolID});
}

// all payments

export const ACTIVE_PAYMENTS_FETCH = "SCHOOL_MONEY/ACTIVE_PAYMENTS_FETCH";
export const ACTIVE_PAYMENTS_FETCH_COMPLETED = "SCHOOL_MONEY/ACTIVE_PAYMENTS_FETCH_COMPLETED";

export function fetchActivePayments(forceApiRefresh) {
  return createAction(ACTIVE_PAYMENTS_FETCH, false, {forceApiRefresh});
}

export function fetchActivePaymentsSucceeded(clubPayments, dinnerPayments, otherPayments, parentalConsentItems) {
  return createAction(ACTIVE_PAYMENTS_FETCH_COMPLETED, false, {clubPayments, dinnerPayments, otherPayments, parentalConsentItems});
}

// clubs

export const CLUB_BOOKING_SESSION_SELECT = "SCHOOL_MONEY/CLUB_BOOKING_SESSION_SELECT";
export const CLUB_BOOKING_ADD_TO_BASKET = "SCHOOL_MONEY/CLUB_BOOKING_ADD_TO_BASKET";
export const CLUB_BOOKING_REMOVE_FROM_BASKET = "SCHOOL_MONEY/CLUB_BOOKING_REMOVE_FROM_BASKET";
export const EXPANDED_CLUB_BOOKING_SET = "SCHOOL_MONEY/EXPANDED_CLUB_BOOKING_SET";
export const CLUB_BOOKINGS_MARK_AS_SEEN = "SCHOOL_MONEY/CLUB_BOOKINGS_MARK_AS_SEEN";
export const STUDENT_CLUB_BOOKINGS_MARK_AS_SEEN = "SCHOOL_MONEY/STUDENT_CLUB_BOOKINGS_MARK_AS_SEEN";
export const CLUB_BOOKING_GO_TO = "SCHOOL_MONEY/CLUB_BOOKING_GO_TO";
export const CLUB_BOOKING_GO_TO_CLEAR = "SCHOOL_MONEY/CLUB_BOOKING_GO_TO_CLEAR";

export function selectClubBookingSession(clubBookingID, weekdayIndex, sessionID) {
  return createAction(CLUB_BOOKING_SESSION_SELECT, false, {clubBookingID, weekdayIndex, sessionID});
}

export function addClubBookingToBasket(clubBookingID, reserve = false) {
  return createAction(CLUB_BOOKING_ADD_TO_BASKET, false, {clubBookingID, reserve});
}

export function removeClubBookingFromBasket(clubBookingID) {
  return createAction(CLUB_BOOKING_REMOVE_FROM_BASKET, false, {clubBookingID});
}

export function setExpandedClubBooking(clubBookingID) {
  return createAction(EXPANDED_CLUB_BOOKING_SET, false, {clubBookingID});
}

export function markClubBookingsAsSeen(clubBookingIDs) {
  return createAction(CLUB_BOOKINGS_MARK_AS_SEEN, false, {clubBookingIDs});
}

export function markStudentClubBookingsAsSeen(studentID) {
  return createAction(STUDENT_CLUB_BOOKINGS_MARK_AS_SEEN, false, {studentID});
}

export function goToClubBooking(clubBookingID) {
  return createAction(CLUB_BOOKING_GO_TO, false, {clubBookingID});
}

export function clearGoToClubBooking() {
  return createAction(CLUB_BOOKING_GO_TO_CLEAR);
}

// dinners

export const DINNER_BOOKING_OPTION_SELECT = "SCHOOL_MONEY/DINNER_BOOKING_OPTION_SELECT";
export const DINNER_BOOKING_ADD_TO_BASKET = "SCHOOL_MONEY/DINNER_BOOKING_ADD_TO_BASKET";
export const DINNER_BOOKING_REMOVE_FROM_BASKET = "SCHOOL_MONEY/DINNER_BOOKING_REMOVE_FROM_BASKET";
export const SET_ALLERGIES_WARNING_STATUS = "SCHOOL_MONEY/SET_ALLERGIES_WARNING_STATUS";
export const SET_EXPANDED_DINNER_BOOKING = "SCHOOL_MONEY/SET_EXPANDED_DINNER_BOOKING";
export const DINNER_BOOKINGS_MARK_AS_SEEN = "SCHOOL_MONEY/DINNER_BOOKINGS_MARK_AS_SEEN";
export const STUDENT_DINNER_BOOKINGS_MARK_AS_SEEN = "SCHOOL_MONEY/STUDENT_DINNER_BOOKINGS_MARK_AS_SEEN";
export const DINNER_BOOKING_GO_TO = "SCHOOL_MONEY/DINNER_BOOKING_GO_TO";
export const DINNER_BOOKING_GO_TO_CLEAR = "SCHOOL_MONEY/DINNER_BOOKING_GO_TO_CLEAR";

export function selectDinnerBookingOption(dinnerBookingID, weekdayIndex, optionID) {
  return createAction(DINNER_BOOKING_OPTION_SELECT, false, {dinnerBookingID, weekdayIndex, optionID});
}

export function addDinnerBookingToBasket(dinnerBookingID) {
  return createAction(DINNER_BOOKING_ADD_TO_BASKET, false, {dinnerBookingID});
}

export function removeDinnerBookingFromBasket(dinnerBookingID) {
  return createAction(DINNER_BOOKING_REMOVE_FROM_BASKET, false, {dinnerBookingID});
}

export function setAllergiesWarningStatus(isEnabled) {
  return createAction(SET_ALLERGIES_WARNING_STATUS, false, {isEnabled});
}

export function setExpandedDinnerBooking(dinnerBookingID) {
  return createAction(SET_EXPANDED_DINNER_BOOKING, false, {dinnerBookingID});
}

export function markDinnerBookingsAsSeen(dinnerBookingIDs) {
  return createAction(DINNER_BOOKINGS_MARK_AS_SEEN, false, {dinnerBookingIDs});
}

export function markStudentDinnerBookingsAsSeen(studentID) {
  return createAction(STUDENT_DINNER_BOOKINGS_MARK_AS_SEEN, false, {studentID});
}

export function goToDinnerBooking(dinnerBookingID) {
  return createAction(DINNER_BOOKING_GO_TO, false, {dinnerBookingID});
}

export function clearGoToDinnerBooking() {
  return createAction(DINNER_BOOKING_GO_TO_CLEAR);
}

// other payments

export const SET_PAYMENT_INSTALLMENT_SELECTED_PRICE = "SCHOOL_MONEY/SET_PAYMENT_INSTALLMENT_SELECTED_PRICE";
export const PAYMENT_INSTALLMENT_ADD_TO_BASKET = "SCHOOL_MONEY/PAYMENT_INSTALLMENT_ADD_TO_BASKET";
export const PAYMENT_INSTALLMENT_REMOVE_FROM_BASKET = "SCHOOL_MONEY/PAYMENT_INSTALLMENT_REMOVE_FROM_BASKET";
export const PAYMENT_REMOVE_FROM_BASKET = "SCHOOL_MONEY/PAYMENT_REMOVE_FROM_BASKET";
export const SET_EXPANDED_PAYMENT = "SCHOOL_MONEY/SET_EXPANDED_PAYMENT";
export const PAYMENTS_MARK_AS_SEEN = "SCHOOL_MONEY/PAYMENTS_MARK_AS_SEEN";
export const STUDENT_PAYMENTS_MARK_AS_SEEN = "SCHOOL_MONEY/STUDENT_PAYMENTS_MARK_AS_SEEN";
export const PAYMENT_GO_TO = "SCHOOL_MONEY/PAYMENT_GO_TO";
export const PAYMENT_GO_TO_CLEAR = "SCHOOL_MONEY/PAYMENT_GO_TO_CLEAR";

export function setPaymentInstallmentSelectedPrice(paymentID, installmentNumber, selectedPrice) {
  return createAction(SET_PAYMENT_INSTALLMENT_SELECTED_PRICE, false, {paymentID, installmentNumber, selectedPrice});
}

export function addPaymentInstallmentToBasket(paymentID, installmentNumber) {
  return createAction(PAYMENT_INSTALLMENT_ADD_TO_BASKET, false, {paymentID, installmentNumber});
}

export function removePaymentInstallmentFromBasket(paymentID, installmentNumber) {
  return createAction(PAYMENT_INSTALLMENT_REMOVE_FROM_BASKET, false, {paymentID, installmentNumber});
}

export function removePaymentFromBasket(paymentID) {
  return createAction(PAYMENT_REMOVE_FROM_BASKET, false, {paymentID});
}

export function setExpandedPayment(paymentID) {
  return createAction(SET_EXPANDED_PAYMENT, false, {paymentID});
}

export function markPaymentsAsSeen(paymentIDs) {
  return createAction(PAYMENTS_MARK_AS_SEEN, false, {paymentIDs});
}

export function markStudentPaymentsAsSeen(studentID) {
  return createAction(STUDENT_PAYMENTS_MARK_AS_SEEN, false, {studentID});
}

export function goToPayment(paymentID) {
  return createAction(PAYMENT_GO_TO, false,  {paymentID});
}

export function clearGoToPayment() {
  return createAction(PAYMENT_GO_TO_CLEAR);
}

// shop

export const SHOP_ITEMS_FETCH = "SCHOOL_MONEY/SHOP_ITEMS_FETCH";
export const SHOP_ITEMS_FETCH_COMPLETED = "SCHOOL_MONEY/SHOP_ITEMS_FETCH_COMPLETED";
export const SHOP_ITEM_SET_BASKET_QUANTITY = "SCHOOL_MONEY/SHOP_ITEM_SET_BASKET_QUANTITY";
export const SHOP_ITEM_REMOVE_FROM_BASKET = "SCHOOL_MONEY/SHOP_ITEM_REMOVE_FROM_BASKET";
export const SHOP_ITEMS_MARK_AS_SEEN = "SCHOOL_MONEY/SHOP_ITEMS_MARK_AS_SEEN";
export const STUDENT_SHOP_ITEMS_MARK_AS_SEEN = "SCHOOL_MONEY/STUDENT_SHOP_ITEMS_MARK_AS_SEEN";
export const SHOP_ITEM_GO_TO = "SCHOOL_MONEY/SHOP_ITEM_GO_TO";
export const SHOP_ITEM_GO_TO_CLEAR = "SCHOOL_MONEY/SHOP_ITEM_GO_TO_CLEAR";
export const SHOP_ITEM_SET_SEARCH_QUERY = "SCHOOL_MONEY/SHOP_ITEM_SET_SEARCH_QUERY";

export function fetchShopItems(forceApiRefresh) {
  return createAction(SHOP_ITEMS_FETCH, false, {forceApiRefresh});
}

export function fetchShopItemsSucceeded(shopItems) {
  return createAction(SHOP_ITEMS_FETCH_COMPLETED, false, {shopItems});
}

export function setShopItemBasketQuantity(shopItemID, studentID, quantity) {
  return createAction(SHOP_ITEM_SET_BASKET_QUANTITY, false, {shopItemID, studentID, quantity});
}

export function removeShopItemFromBasket(shopItemID, studentID) {
  return createAction(SHOP_ITEM_REMOVE_FROM_BASKET, false, {shopItemID, studentID});
}

export function markShopItemsAsSeen(shopItemIDs) {
  return createAction(SHOP_ITEMS_MARK_AS_SEEN, false, {shopItemIDs});
}

export function markStudentShopItemsAsSeen(studentID) {
  return createAction(STUDENT_SHOP_ITEMS_MARK_AS_SEEN, false, {studentID});
}

export function goToShopItem(shopItemID, studentID) {
  return createAction(SHOP_ITEM_GO_TO, false, {shopItemID, studentID});
}

export function clearGoToShopItem() {
  return createAction(SHOP_ITEM_GO_TO_CLEAR);
}

export function setShopItemSearchQuery(searchQuery) {
  return createAction(SHOP_ITEM_SET_SEARCH_QUERY, false, {searchQuery});
}

// history

export const HISTORY_FETCH = "SCHOOL_MONEY/HISTORY_FETCH";
export const HISTORY_FETCH_COMPLETED = "SCHOOL_MONEY/HISTORY_FETCH_COMPLETED";

export function fetchHistory(forceApiRefresh) {
  return createAction(HISTORY_FETCH, false, {forceApiRefresh});
}

export function fetchHistorySucceeded(history) {
  return createAction(HISTORY_FETCH_COMPLETED, false, {history});
}

// parental consent

export const PARENTAL_CONSENT_UPDATE = "SCHOOL_MONEY/PARENTAL_CONSENT_UPDATE";
export const PARENTAL_CONSENT_UPDATE_SUCCEEDED = "SCHOOL_MONEY/PARENTAL_CONSENT_UPDATE_SUCCEEDED";
export const PARENTAL_CONSENT_UPDATE_FAILED = "SCHOOL_MONEY/PARENTAL_CONSENT_UPDATE_FAILED";
export const PENDING_PARENTAL_CONSENT_ITEMS_CLEAR_SAVED = "SCHOOL_MONEY/PENDING_PARENTAL_CONSENT_ITEMS_CLEAR_SAVED";
export const PENDING_PARENTAL_CONSENT_ITEMS_CLEAR_FAILURES = "SCHOOL_MONEY/PENDING_PARENTAL_CONSENT_ITEMS_CLEAR_FAILURES";
export const PARENTAL_CONSENT_ITEM_GO_TO = "SCHOOL_MONEY/PARENTAL_CONSENT_ITEM_GO_TO";

export function updateParentalConsent(itemID, status) {
  return createAction(PARENTAL_CONSENT_UPDATE, false, {itemID, status});
}

export function updateParentalConsentSucceeded(itemID, status) {
  return createAction(PARENTAL_CONSENT_UPDATE_SUCCEEDED, false, {itemID, status});
}

// TODO: handle this error properly
export function updateParentalConsentFailed(itemID, error) {
  // this isn't an error because we want to handle it
  return createAction(PARENTAL_CONSENT_UPDATE_FAILED, false, {itemID, error});
}

export function clearSavedPendingParentalConsentItems() {
  return createAction(PENDING_PARENTAL_CONSENT_ITEMS_CLEAR_SAVED);
}

export function clearFailedPendingParentalConsentItems() {
  return createAction(PENDING_PARENTAL_CONSENT_ITEMS_CLEAR_FAILURES);
}

export function goToParentalConsentItem(itemID) {
  return createAction(PARENTAL_CONSENT_ITEM_GO_TO, false, {itemID});
}

// checkout

export const CHECKOUT_START = "SCHOOL_MONEY/TRANSACTION_CREATE";
export const CHECKOUT_TRANSACTION_DETAILS_SET = "SCHOOL_MONEY/CHECKOUT_TRANSACTION_DETAILS_SET";
export const CHECKOUT_TRANSACTION_PROCESS = "SCHOOL_MONEY/CHECKOUT_TRANSACTION_PROCESS";
export const CHECKOUT_COMPLETE = "SCHOOL_MONEY/CHECKOUT_COMPLETE";
export const CHECKOUT_CLOSE = "SCHOOL_MONEY/CHECKOUT_CLOSE";
export const CHECKOUT_ERROR_SET = "SCHOOL_MONEY/CHECKOUT_ERROR_SET";
export const CHECKOUT_ERROR_CLEAR = "SCHOOL_MONEY/CHECKOUT_ERROR_CLEAR";
export const ERROR_PAYSAFE = "SCHOOL_MONEY/ERROR_PAYSAFE";
export const ERROR_SECURE_TRADING = "SCHOOL_MONEY/ERROR_SECURE_TRADING";
export const CLEAR_SECURE_TRADING_WALLET_PAY_JWT_STRING = "SCHOOL_MONEY/CLEAR_SECURE_TRADING_WALLET_PAY_JWT_STRING";
export const SECURE_TRADING_REFERENCE_SET = "SCHOOL_MONEY/SECURE_TRADING_REFERENCE_SET";
export const CLEAR_SECURE_TRADING_GOOGLE_PAY_JWT_STRING = "SCHOOL_MONEY/CLEAR_SECURE_TRADING_GOOGLE_PAY_JWT_STRING";
export const CHECKOUT_RESTART = "SCHOOL_MONEY/CHECKOUT_RESTART";

export function startCheckout(schoolID) {
  return createAction(CHECKOUT_START, false, {schoolID});
}

export function setCheckoutTransactionDetails(transactionID, totalToPay, walletPayJWTString) {
  return createAction(CHECKOUT_TRANSACTION_DETAILS_SET, false, {transactionID, totalToPay, walletPayJWTString});
}

export function processCheckoutTransaction(paysafeSingleUseToken, cardholderName) {
  return createAction(CHECKOUT_TRANSACTION_PROCESS, false, {paysafeSingleUseToken, cardholderName});
}

export function completeCheckout() {
  return createAction(CHECKOUT_COMPLETE);
}

export function closeCheckout() {
  return createAction(CHECKOUT_CLOSE);
}

export function setCheckoutError(error, errorCode) {
  return createAction(CHECKOUT_ERROR_SET, true, {error, errorCode});
}

export function clearCheckoutError() {
  return createAction(CHECKOUT_ERROR_CLEAR);
}

export function paysafeError(error) {
  return createAction(ERROR_PAYSAFE, true, {error});
}

export function secureTradingError(error) {
  return createAction(ERROR_SECURE_TRADING, true, {error});
}

export function clearWalletPayJWTString() {
  return createAction(CLEAR_SECURE_TRADING_WALLET_PAY_JWT_STRING);
}

export function checkoutRestart() {
  return createAction(CHECKOUT_RESTART);
}

// guide
export const GUIDE_OPEN = "SCHOOL_MONEY/GUIDE_OPEN";
export const GUIDE_CLOSE = "SCHOOL_MONEY/GUIDE_CLOSE";

export function openGuide() {
  return createAction(GUIDE_OPEN);
}

export function closeGuide(timestamp) {
  return createAction(GUIDE_CLOSE, false, {timestamp});
}

// audit
export const SAVE_AUDIT = "SCHOOL_MONEY/SAVE_AUDIT";

export function saveAudit(type) {
  return createAction(SAVE_AUDIT, false, {type});
}



// WEBPACK FOOTER //
// ./src/state/school_money/actions.js